/** @format */

import React from 'react';
import PropTypes from 'prop-types';
import MuiTableHead from '@mui/material/TableHead';
import TableRow from './TableRow';
import TableHeadCell from './TableHeadCell';
import TableSelectHeadCell from './TableSelectHeadCell';
import styled from 'src/ui/library/styled';

const styles = theme => ({
  root: {},
  headStyle: {
    color: 'red',
  },
});

class TableHead extends React.Component {
  static propTypes = {
    /** Styles to be applied to component */
    classes: PropTypes.object,
    /**
     * Read Only mode will force table to ignore renderComponent per columns and display cell value.
     * It will also make rows not selectable.
     */
    readOnly: PropTypes.bool.isRequired,
    /** Developer styles overrides */
    styleOverrides: PropTypes.object.isRequired,
    /** Populate first column with selectable radio button */
    selectableRows: PropTypes.bool.isRequired,
    /** Callback function for sort changes */
    onChangeSort: PropTypes.func,
  };

  render() {
    const { columns, selectableRows, onChangeSort, styleOverrides, readOnly, showTableHeader, hardDisplay, enableHeaderSelection, name, markAllSelectionFlag } = this.props;
    const totalColumns = columns.length;

    return (
      <MuiTableHead>
        <TableRow rowType={'head'} showTableHeader>
          {!readOnly && selectableRows && <TableSelectHeadCell showTableHeader={showTableHeader} />}
          {columns.map((col, colIndex) =>
            col.visible ? (
              <TableHeadCell
                styleOverrides={{ TableHeadCell: styleOverrides.TableHeadCell }}
                onChangeSort={onChangeSort}
                key={colIndex}
                colIndex={colIndex}
                colData={col}
                totalColumns={totalColumns}
                showTableHeader={showTableHeader}
                hardDisplay={hardDisplay}
                idName={col.id}
                enableHeaderSelection={enableHeaderSelection}
                name={name}
                markAllSelectionFlag={markAllSelectionFlag}
              />
            ) : null,
          )}
        </TableRow>
      </MuiTableHead>
    );
  }
}

export default styled(TableHead)(styles);
